@if (isLoading() || (promptPresets()?.length ?? 0) > 0) {
  <div class="mt-5 flex flex-col items-start gap-2">
    <p class="text-xs text-foreground-primary-60">{{ 'ai-assistant.prompt-presets' | translate }}</p>
    @if (isLoading()) {
      <div class="flex">
        <app-loading-skeleton
          class="h-[36px] w-[150px]"
          viewBox="0 0 150 36"
          [preserveAspectRatio]="false"
          backgroundTextClass="text-background-container-primary"
        >
          <svg:rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
        </app-loading-skeleton>
      </div>
    }
    <div class="flex flex-wrap gap-2">
      @for (promptPreset of promptPresets() ?? []; track promptPreset.id) {
        <button
          type="button"
          class="flex items-center gap-3 rounded-radius-secondary bg-background-container-primary px-2 py-2 text-left text-sm font-medium text-action-secondary transition-colors hover:bg-background-container-secondary disabled:cursor-not-allowed disabled:opacity-50 dark:text-foreground-primary-100"
          [disabled]="disabled()"
          (click)="onPromptPresetSelected(promptPreset)"
        >
          <span>{{ promptPreset.name }}</span>
          <span class="text-xs font-normal text-foreground-primary-40">{{ 'ai-assistant.run' | translate }}</span>
        </button>
      }
    </div>
  </div>
}
